export default "/_next/static/images/3b85a94fb32d94dd4b34cbbdc3c7b683.png";